import { useState } from 'react';
import { API_URL } from '@constants';
import { ApiError, useApiConfig } from '@hooks/useApiConfig';

const ENDPOINT_URL = '/spaces';

export interface DeleteSpaceSuccessResponse {
    status: number;
    success: boolean;
    message: string;
}

/**
 * Requests endpoint to delete a space.
 */
export const useDeleteSpace = () => {
    const { getHeaders, handleCommonErrors } = useApiConfig();
    const [loading, setLoading] = useState<boolean>(false);
    const [success, setSuccess] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const [lastResponseTime, setLastResponseTime] = useState<number | null>(null);

    const request = async (uuid: string) => {
        setLoading(true);
        setSuccess(false);
        setErrorMessage(null);

        try {
            const response = await fetch(`${API_URL}${ENDPOINT_URL}/${uuid}`, {
                method: 'DELETE',
                headers: getHeaders(),
            });

            const json = await response.json();

            if (!response.ok) {
                const error = new Error(json.message || json.error || 'Erro ao eliminar espaço') as ApiError;
                error.statusCode = response.status;
                setErrorMessage(json.message || json.error || 'Erro ao eliminar espaço');
                throw error;
            }

            setSuccess(true);
            setErrorMessage(null);

            return json as DeleteSpaceSuccessResponse;
        } catch (err: any) {
            setSuccess(false);
            handleCommonErrors(err);
        } finally {
            setLoading(false);
            setLastResponseTime(Date.now());
        }
    };

    return {
        request,
        loading,
        success,
        errorMessage,
        lastResponseTime,
    };
};
